import { CategoryId } from '@business/entities/category';
import { PageQuery } from '../common';
import { CategoryResponse } from './../category/CategoryResponse';
import { OrderVendorId } from './OrderVendorResponse';
import { PricingTierId, PricingTierResponse } from './PricingTierResponse';
import { LabourTypeResponse } from '../labour-type';
import { ServiceProviderId } from '../tm/TmServiceProviderResponse';
import { CategoryOptionId } from '../category_option';
import { TmEstimatorTempateResponse } from '../tm/TmTemplateEstimatorResponse';

export type SearchProductResponse = Pick<
  OrderProductResponse,
  'id' | 'title' | 'sku' | 'description' | 'image' | 'categories' | 'providers' | 'dependantFactor'
>;

export type OrderProductId = string;

export interface LabourItemResponse {
  hour: number;
  cost: number;
  price: number;
  labourTypeId: string;
  labourType: LabourTypeResponse;
}
export interface OrderProductResponse {
  id: OrderProductId;
  title: string;
  description: string;
  sku: string;
  cost: number;
  stock: number;
  image?: string | File;
  vendorId: OrderVendorId;
  vendorName: string;
  categories: CategoryResponse[];
  categoryIds: CategoryId[];
  prices: OrderProductTierResponse[];
  active: boolean;
  isInventory: boolean;
  taxable: boolean;
  isDiscount: boolean;
  expenseAccountId: string;
  assetAccountId: string;
  incomeAccountId: string;
  unitOfMeasure: string;
  qtyPerUM?: string;
  classId: string;
  missingAccounts: boolean;
  labourType: LabourTypeResponse;
  labourHour: number;
  labourItems: LabourItemResponse[];
  brandId: string;
  homeOwnerDescription: string;
  subcontractorWoCustomName: string;
  subcontractorWoDisplayQuantity: boolean;
  subcontractorWoDisplayPrice: boolean;
  weProvidedBy: boolean;
  availableAutomaticSubproject: boolean;
  proposalDisplay: ProposalDisplayValueEnum;
  laborUnitPrice: number;
  materialUnitPrice: number;
  unitPrice?: number;
  internalMaterialMarkupPerUnitPrice: number;
  internalMaterialPerUnitPrice: number;
  internalLabourMarkupPerHourPrice: number;
  internalLabourPerHourPrice: number;
  externalLabourMarkupPerHourPrice: number;
  externalLabourPerHourPrice: number;
  rollup: string;
  note: string;
  criteriaFormula?: string;
  qtyFormula?: string;
  markupFactor?: string;
  estimatorTemplateGroupId?: string;
  orderProductId?: string;
  homeOwnerName: string;
  subcontractorWoCustomDescription: string;
  unitType: string;
  providers: ProviderPricesResponse[];
  dependantFactor: number;
  applicationType: OrderProductApplicationType;
  formulas: OrderProductEstimateTemplateFormulaResponse[];
  hasCriteriaFormula: boolean;
}

export type OrderProductPricingResponse = Pick<
  OrderProductResponse,
  | 'id'
  | 'title'
  | 'description'
  | 'sku'
  | 'image'
  | 'categoryIds'
  | 'homeOwnerDescription'
  | 'laborUnitPrice'
  | 'materialUnitPrice'
  | 'internalMaterialPerUnitPrice'
  | 'internalLabourPerHourPrice'
  | 'providers'
>;
export interface ProviderPricesResponse {
  providerId: ServiceProviderId;
  optionId: CategoryOptionId;
  laborPrice: number;
  materialPrice: number;
}

export interface OrderProductEstimateTemplateFormulaResponse {
  templateIds: string[];
  criteriaFormula?: string;
  qtyFormula?: string;
  template: Pick<TmEstimatorTempateResponse, 'id' | 'title' | 'type'>[];
}

export interface OrderProductTierResponse {
  id: number;
  price: number;
  tierId: PricingTierId;
  productId: OrderProductId;
  tier: PricingTierResponse;
}

export interface ProductPageQuery extends PageQuery {
  status?: string;
  categories?: CategoryId[];
  brandId?: string;
}

export enum ProposalDisplayLableEnum {
  'quantity' = 'Quantity',
  'bulletPoint' = 'Bullet Point',
  'none' = 'None',
}
export enum ProposalDisplayValueEnum {
  'quantity' = 'quantity',
  'bulletPoint' = 'bullet_point',
  'none' = 'none',
}

export enum UnitTypeValue {
  singleUnit = 'singleUnit',
  squareFoot = 'squareFoot',
}

export const UnitTypeValueItems = [UnitTypeValue.singleUnit, UnitTypeValue.squareFoot];

export enum OrderProductApplicationType {
  everyProject = 0,
  onlyOnRequest = 1,
  basedOnCriteria = 2,
}

export const OrderProductApplicationTypeItems = [
  OrderProductApplicationType.everyProject,
  OrderProductApplicationType.onlyOnRequest,
  OrderProductApplicationType.basedOnCriteria,
];
